import { encryptbody } from "apputils/encrypt";
import getuser from "aws_utils/getAuthuser";
import { getCurrentSession } from "aws_utils/getCurrentSession";
import { fetchAPI } from "lib/fetch";

export const addSession = async () => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/sessions`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;
  const datauser = await getuser();
  const session = await getCurrentSession();
  const ijt = session.getIdToken().getJwtToken();

  try {
    const res = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        id: datauser.username,
        ijt: ijt,
      }),
    });

    return res;
  } catch (error) {
    // console.log("error from mongocall addUser", error);
    return null;
  }
};

export const generateToken = async () => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/generate`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  const datauser = await getuser();
  const session = await getCurrentSession();
  const ijt = session.getIdToken().getJwtToken();
  const body = {
    id: datauser.username,
    idToken: ijt,
  };

  const encryptedBody = await encryptbody(body);

  try {
    const token = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        data: encryptedBody,
      }),
      // data: JSON.stringify({
      //   id: datauser.username,
      //   idToken: ijt,
      // }),
    });

    // console.log("generate token res", token);

    return token.authToken;
  } catch (error) {
    return null;
  }
};
